module.exports = __webpack_public_path__ + "img/wangdian.d8d952bb.png";